let _this = {
    /*-------------------------------------------------------------------------------
      # Cache dom and strings
    -------------------------------------------------------------------------------*/
    $dom: {
      body: $('body')
    },

    vars: {},

    /*-------------------------------------------------------------------------------
      # Initialize
    -------------------------------------------------------------------------------*/
    init: function () {
        const marquees = $(".marquee");

        class Marquee {
            constructor({ el }) {
                this.el = el;
                this.marqueeAnimation = [
                    { transform: "translateX(0)" },
                    { transform: `translateX(calc(-100% - var(--marqueGap,0)))` }
                ];

                this.marqueeTiming = {
                    duration: $(this.el).data("duration") * 10000,
                    direction: $(this.el).data("reverse") ? "reverse" : "normal",
                    iterations: Infinity
                };
                this.animations = [];
                this.SLOWDOWN_RATE = 0.2;
                this.cloneMarqueeGroup();
                this.init();
            }

            init() {
                for (const m of this.marquee__groups) {
                    let q = m.animate(this.marqueeAnimation, this.marqueeTiming);

                    this.animations.push(q);
                }

                this.initEvents();
            }

            slowDownAnimations() {
                for (const a of this.animations) {
                    a.playbackRate = this.SLOWDOWN_RATE;
                }
            }

            resumeAnimationSpeed() {
                for (const a of this.animations) {
                    a.playbackRate = true;
                }
            }

            initEvents() {
                $(this.el).on("mouseenter", () => this.slowDownAnimations());
                $(this.el).on("mouseleave", () => this.resumeAnimationSpeed());
            }

            cloneMarqueeGroup() {
                let clone = $(this.el).find(".marquee__group").clone(true);
                clone.addClass("clone");
                $(this.el).append(clone);
                this.marquee__groups = Array.from(
                    $(this.el).find(".marquee__group")
                );
            }
        }

        marquees.each(function() {
            new Marquee({ el: this });
        });
    },
};

export default _this;
